// extracted by mini-css-extract-plugin
module.exports = {"root":"neighboring-module__root___30sU0","left":"neighboring-module__left___3GPYa","right":"neighboring-module__right___15bTz"};